// New message — ports app/(privado)/para-sempre/adicionar/page.tsx.

import { Link } from "react-router";
import { Flourish } from "@/components/ui/Flourish";
import { FormMensagem } from "@/components/forms/FormMensagem";
import { useTitle } from "@/components/ui/useTitle";
import { usePhotoSummary } from "@/api/queries";

export function ParaSempreAdicionar() {
  useTitle("Nova mensagem");
  const fotos = usePhotoSummary();

  return (
    <main className="mx-auto max-w-xl px-6 py-16">
      <header className="text-center">
        <p className="font-display text-lg italic text-ouro-600">Mais uma página</p>
        <h1 className="mt-2 font-display text-4xl text-tinta">Nova mensagem</h1>
        <div className="my-6">
          <Flourish />
        </div>
      </header>

      <FormMensagem fotos={fotos.data ?? []} />

      <div className="mt-10 text-center">
        <Link
          to="/para-sempre"
          className="text-sm text-ouro-600 underline-offset-4 transition-colors hover:text-ouro hover:underline"
        >
          ← Voltar
        </Link>
      </div>
    </main>
  );
}
